const toNumber = (value) => {
  if (value == null || value === "") return null;
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
};

/** "YYYY-MM-DD" → "DD.MM.YYYY" — формат, который уже показывает таблица */
const formatEntryDate = (value) => {
  if (!value) return "";
  const [year, month, day] = String(value).slice(0, 10).split("-");
  if (!year || !month || !day) return String(value);
  return `${day}.${month}.${year}`;
};

const pushAnalytic = (list, label, value) => {
  if (value) list.push({ label, value });
};

/**
 * Проводка GET /finance/journal → строка журнала.
 * В ответе нет названий счетов, субконто и управленческих аналитик:
 * в таблицу попадают только то, что реально пришло.
 */
export const mapJournalEntry = (item) => {
  const analyticsDt = [];
  const analyticsKt = [];
  pushAnalytic(analyticsDt, "Отделение", item.department_dt_name);
  pushAnalytic(analyticsDt, "Валюта", item.currency_dt);
  pushAnalytic(analyticsKt, "Отделение", item.department_ct_name);
  pushAnalytic(analyticsKt, "Валюта", item.currency_ct);

  return {
    id: item.id,
    fromApi: true,
    date: formatEntryDate(item.entry_date),
    document: item.document_ref || item.registrator || "—",
    hasWarning: item.is_active === false,
    warningTitle: item.is_active === false ? "Проводка неактивна" : undefined,
    organization: item.organization_name || "",
    accountDt: item.account_dt_code || null,
    accountKt: item.account_ct_code || null,
    analyticsDt,
    analyticsKt,
    quantity: toNumber(item.quantity),
    amount: toNumber(item.amount_kzt),
    source: "1C Oper",
    dataType: "Исходные данные",
    budgetVersion: null,
    comment: item.document_comment || null,
    content: item.content || null,
    registrator: item.registrator || null,
    journalNumber: item.journal_number || null,
    lineNo: item.line_no ?? null,
    currencyCode: item.currency_code || null,
    amountFx: toNumber(item.amount_fx),
    currencyDt: item.currency_dt || null,
    currencyKt: item.currency_ct || null,
    departmentDt: item.department_dt_name || null,
    departmentKt: item.department_ct_name || null,
  };
};
